import React, { useEffect, useState, useCallback } from "react";
import { ChevronDown, Filter } from "lucide-react";
import KPICards from "./KPICards";
import JobActivityChart from "./JobActivityChart";
import CreditLimitSection from "./CreditLimitSection";
import DemographicsSection from "./DemographicsSection";
import EducationSection from "./EducationSection";
import SidebarNew from "../../components/SidebarNew/SidebarNew";
import "./Dashboard.scss";
import graphqlRequest from "../../requestMethod";

const Dashboard = () => {
  // const [userCardData, setUserCardData] = useState();
  let [hospitalBranchData, setHospitalBranchData] = useState([]);
  const [hospitalBranch, setHospitalBranch] = useState("");
  const [hospitalBranchId, setHospitalBranchId] = useState("");
  const [locumHoursData, setLocumHoursData] = useState(null);
  const [isNewBranch, setIsNewBranch] = useState(false);
  const [isLoadingBranch, setIsLoadingBranch] = useState(true);
  const [branchError, setBranchError] = useState(null);
  const [selectedBranchData, setSelectedBranchData] = useState(null);
  const currentYear = new Date().getFullYear();

  const currentDate = new Date();
  const formattedCurrentDate = currentDate.toISOString().split("T")[0];

  const [checkInDate, setCheckInDate] = useState("");
  const [checkOutDate, setCheckOutDate] = useState(formattedCurrentDate);

  const [selectedLocation, setSelectedLocation] = useState("All");
  const [selectedTimeline, setSelectedTimeline] = useState("This Year");
  const [selectedShift, setSelectedShift] = useState('Morning');

  const [loading, setLoading] = useState(false);

  const locations = ["All Branch", "Jobizo Gurgaon", "Jobizo Bengaluru"];
  const timelines = [
    // "Select Timeline", 
    "This Year", "This Month", "This Week"];
  const [filters, setFilters] = useState({
    jobGraphType: 'year',
    year: currentYear,
    month: 5,
    week: 2
  });
  const getTimelineType = (timeline) => {
    switch (timeline) {
      // case "Select Timeline":
      case "This Year":
        return "thisYear";
      case "This Month":
        return "thisMonth";
      case "This Week":
        return "thisWeek";
      default:
        return "thisYear";
    }
  };

  const timelineType = getTimelineType(selectedTimeline);

  // Fetch branch data when component mounts or hospital changes
  useEffect(() => {
    const fetchBranches = async () => {
      if (!token) {
        const authData = localStorage.getItem("auth");
        token = JSON.parse(authData)?.accessToken;
      }
      
      try {
        setIsLoadingBranch(true);
        setBranchError(null);
        
        const query = `
          query {
            withAuth(token: "${token}") {
              listMiniJobBranches {
                id
                jobLocation {
                  hospitalName
                  branchName
                }
                creditLimit
                utilizedLimit
                creditNote
                isNewBranch
                branchActivated
                shiftApproval
                creditThresholdPercent
                latePaymentFeePercent
                billingInfo {
                  serviceFeePercent
                  platformFeePercent
                  billingMode
                  billingCycle
                  paymentDuePeriodDays
                  bufferDays
                }
              }
            }
          }
        `;
        
        const response = await graphqlRequest(query);
        const branches = response?.data?.withAuth?.listMiniJobBranches || [];
        
        // Update branches data
        setHospitalBranchData(branches);
        
        // If there's exactly one branch, set it as default
        if (branches.length === 1) {
          const firstBranch = branches[0];
          setHospitalBranch(firstBranch?.jobLocation?.branchName);
          setHospitalBranchId(firstBranch?.id);
          setSelectedBranchData(firstBranch);
          setIsNewBranch(firstBranch?.isNewBranch || false);
        } else if (hospitalBranchId) {
          // Find the selected branch
          const selectedBranch = branches.find(branch => branch.id === hospitalBranchId);
          if (selectedBranch) {
            setSelectedBranchData(selectedBranch);
            setIsNewBranch(selectedBranch.isNewBranch || false);
          }
        }
      } catch (error) {
        console.error("Error fetching branches:", error);
        setBranchError('Failed to load branch data');
        setIsLoadingBranch(false);
      }
    };

    fetchBranches();
  }, [hospitalBranchId]);

  // 🔄 Automatically update dates based on selected timeline
  useEffect(() => {
    const today = new Date();
    let checkIn;

    switch (timelineType) {
      case "thisMonth":
        checkIn = new Date(
          today.getFullYear(),
          today.getMonth() - 1,
          today.getDate()
        );
        break;
      case "thisWeek":
        checkIn = new Date(today);
        checkIn.setDate(today.getDate() - 7);
        break;
      case "thisYear":
      default:
        checkIn = new Date(
          today.getFullYear(),
          today.getMonth() - 12,
          today.getDate()
        );
        break;
    }

    setCheckInDate(checkIn.toISOString().split("T")[0]);
    setCheckOutDate(today.toISOString().split("T")[0]);
  }, [selectedTimeline]);

  // 📦 Fetch data when dates change
  // useEffect(() => {
  //   fetchUserDataFunction();
  // }, [checkInDate, checkOutDate]);

  // 📡 Token from localStorage
  let data = localStorage.getItem("auth");
  let token = JSON.parse(data)?.accessToken;

  // // 🔍 Fetching function
  // let fetchUserDataFunction = () => {
  //   const query = `
  //   query {
  //     withAuth(token: "${token}") {
  //       listJobCounts(startTime: "${checkInDate}", endTime: "${checkOutDate}", type: ${timelineType}) {
  //         locumJobs
  //         permanentJob
  //         activeLocumJobs
  //         interviewScheduled
  //         locumJobsTotal
  //         permanentJobTotal
  //         interviewScheduledTotal
  //         activeLocumJobsTotal
  //         totallocumJobs
  //         totalPermanentJobs
  //         totalInterviewScheduled
  //         totalActiveLocumJob
  //         yesterdayPostedJobs
  //         last12MonthJobs
  //         activeOpenLocumJobs
  //         locumOngoingJobs
  //       }
  //     }
  //   }
  // `;

  //   graphqlRequest(query).then((response) => {
  //     if (response?.data?.withAuth?.listJobCounts) {
  //       setUserCardData(response.data.withAuth.listJobCounts);
  //     }
  //   });
  // };

  // // 🔍 Debug logs
  // console.log("token:", token);
  // console.log("checkIn:", checkInDate);
  // console.log("checkOut:", checkOutDate);
  // console.log("timelineType:", timelineType);
  // console.log("userCardData:", userCardData);

  function fetchHospitalDropdownData() {
    const query = `
  query{
    withAuth(token:"${token}"){
    listMiniJobBranches{
            id
            jobLocation {
              hospitalName
              branchName
            }
            creditLimit
            utilizedLimit
         }
         }
       }
`;
    graphqlRequest(query).then((response) => {
      // console.log("response>>>>>", response);
      setHospitalBranchData(response.data.withAuth.listMiniJobBranches);
    });
  }

  // Fetch locum hours data
  const fetchLocumHours = async (
    branchId,
    shift = "Morning",
    jobGraphType = "year",
    year = currentYear,
    month = 7,
    week = 1
  ) => {
    setLoading(true); // 🔥 start loading

    try {
      const query = `
      query {
        withAuth(token: "${token}") {
          listTotalLocumHours(
            branchId: "${branchId}",
            timelineType: "${timelineType}",
            type: "${shift}",
            jobGraphType: "${jobGraphType}",
            selectedYear: ${year},
            selectedMonth: ${month},
            selectedWeek: ${week}
          ) {
            totalLocumHours
            completedJobsCount
            upcomingJobsThisWeekCount
            upcomingJobsNextWeekCount
            totallocumhires
            repeatHireRate
            totalJobsPostedCount
            openJobsCount
            ongoingJobsCount
            jobizoappusers
            jobinvitessentcount
            shiftAnalysis
            doctorPercentage
            nursePercentage
            otherProfessionalPercentage
            malePercentage
            femalePercentage
            otherGenderPercentage
                   ageGroupGraph {
         group_20_30
         group_31_40
         group_41_50
         group_51_60
         group_60_plus
         }
        
         experienceGraph {
         range_0_3
         range_3_6
         range_6_10
         range_10_plus
         }
        
         totalJobsPostedGraph {
         month
         week
         day
         count
         }
        
         topQualificationsGraph {
         qualification
         count
         }
        
         topSpecializationsGraph {
         specialization
         count
         percentage
         }
          }
        }
      }
    `;

      const response = await graphqlRequest(query);

      if (response?.data?.withAuth?.listTotalLocumHours) {
        const data = response.data.withAuth.listTotalLocumHours;
        setLocumHoursData(data);

        localStorage.setItem(
          "upcomingJobsThisWeekCount",
          data.upcomingJobsThisWeekCount
        );
        localStorage.setItem("openJobsCount", data.openJobsCount);
        localStorage.setItem("completedJobsCount", data.completedJobsCount);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false); // 🔥 stop loading (important)
    }
  };
  // const fetchLocumHours = (branchId, shift = 'Morning', jobGraphType = 'year', year = 2025, month = 7, week = 1) => {
  //   const query = `
  //     query {
  //       withAuth(token: "${token}") {
  //         listTotalLocumHours(
  //           branchId: "${branchId}",
  //           timelineType: "${timelineType}",
  //           type: "${shift}",
  //           jobGraphType: "${jobGraphType}",
  //           selectedYear: ${year},
  //           selectedMonth: ${month},
  //           selectedWeek: ${week}
  //         ) {
  //       totalLocumHours
  //       completedJobsCount
  //       upcomingJobsThisWeekCount
  //       upcomingJobsNextWeekCount
  //       totallocumhires
  //       repeatHireRate
  //       totalJobsPostedCount
  //       openJobsCount
  //       ongoingJobsCount
  //       jobizoappusers
  //       jobinvitessentcount
  //       shiftAnalysis
  //       doctorPercentage
  //       nursePercentage
  //       otherProfessionalPercentage
  //       malePercentage
  //       femalePercentage
  //       otherGenderPercentage
        
  //       ageGroupGraph {
  //       group_20_30
  //       group_31_40
  //       group_41_50
  //       group_51_60
  //       group_60_plus
  //       }
        
  //       experienceGraph {
  //       range_0_3
  //       range_3_6
  //       range_6_10
  //       range_10_plus
  //       }
        
  //       totalJobsPostedGraph {
  //       month
  //       week
  //       day
  //       count
  //       }
        
  //       topQualificationsGraph {
  //       qualification
  //       count
  //       }
        
  //       topSpecializationsGraph {
  //       specialization
  //       count
  //       percentage
  //       }
  //       }
  //     }
  //   }
  // `;

  //   graphqlRequest(query).then((response) => {
  //     if (response?.data?.withAuth?.listTotalLocumHours) {
  //       // setLocumHoursData(response?.data?.withAuth?.listTotalLocumHours);
  //       const data = response?.data?.withAuth?.listTotalLocumHours;
  //       setLocumHoursData(data);
  //       console.log("data======",data);
        
  //       localStorage.setItem(
  //         "upcomingJobsThisWeekCount",
  //         data.upcomingJobsThisWeekCount
  //       );
  //       localStorage.setItem("openJobsCount", data.openJobsCount);
  //       localStorage.setItem("completedJobsCount", data.completedJobsCount);
  //     }
  //   });
  // };

  const hospitalBranchOptions = [];
  hospitalBranchData.map((ele) => {
    // console.log("ele", ele);
    let obj = {
      key: ele.id,
      value: ele.jobLocation.branchName,
    };

    hospitalBranchOptions.push(obj);
  });

  console.log("hospitalBranchOptions", hospitalBranchOptions);

  const handleBranchFilterChange = (e) => {
    const selectedBranchName = e.target.value;
    const selectedBranch = hospitalBranchData.find(
      (item) => item.jobLocation.branchName === selectedBranchName
    );
    const branchIdToUse = selectedBranch ? selectedBranch.id : "";

    setHospitalBranch(selectedBranchName);
    setHospitalBranchId(selectedBranch?.id || "");
    fetchLocumHours(branchIdToUse, selectedShift);
    console.log("branchIdToUse===", branchIdToUse);
  };

  const handleTimelineChange = (e) => {
    const newTimeline = e.target.value;
    setSelectedTimeline(newTimeline);
    // The useEffect for selectedTimeline will trigger and update the dates
    // Then the useEffect for hospitalBranchId will call fetchLocumHours
  };

  const handleShiftChange = (shift) => {
    setSelectedShift(shift);
    if (hospitalBranchId) {
      fetchLocumHours(hospitalBranchId, shift);
    }
  };

  useEffect(() => {
    fetchHospitalDropdownData();
  }, []);
  useEffect(() => {
   
      fetchLocumHours(
        hospitalBranchId,
        selectedShift,
        filters.jobGraphType,
        filters.year,
        filters.month,
        filters.week
      );
    
  }, [hospitalBranchId, timelineType, selectedShift, filters]);
  const handleFilterChange = (newFilters) => {
    setFilters(prev => ({
      ...prev,
      ...newFilters
    }));
  };
  console.log(
    "hospitalBranchData",
    hospitalBranchData,
    hospitalBranch,
    hospitalBranchId
  );

  return (
    <div className="dashboard">
      {/* Header */}
      <div className="dashboard__header">
        <h1 className="dashboard__title">Dashboard</h1>
        <div className="dashboard__filters">
          {/* Location Filter */}
          <div className="dashboard__filter">
            <div className="dashboard__filter-inner">
              <Filter className="dashboard__filter-icon" />
              <select
                value={hospitalBranch}
                onChange={handleBranchFilterChange}
                className="dashboard__select"
              >
                <option value="">All Branch</option>
                {hospitalBranchData.map((branch) => (
                  <option key={branch.id} value={branch.jobLocation.branchName}>
                    {branch.jobLocation.branchName}
                  </option>
                ))}
              </select>

              {/* <ChevronDown className="dashboard__select-icon" /> */}
            </div>
          </div>

          {/* Timeline Filter */}
          <div className="dashboard__filter">
            <div className="dashboard__filter-inner">
              <Filter className="dashboard__filter-icon" />
              <select
                value={selectedTimeline}
                onChange={handleTimelineChange}
                className="dashboard__select"
              >
                {timelines.map((timeline) => (
                  <option key={timeline} value={timeline}>
                    {timeline}
                  </option>
                ))}
              </select>
              {/* <ChevronDown className="dashboard__select-icon" /> */}
            </div>
          </div>
        </div>
      </div>

      {/* Key Analytics Section */}
      <KPICards
        selectedLocation={hospitalBranch}
        locumHoursData={locumHoursData}
        onShiftChange={handleShiftChange}
        selectedShift={selectedShift}
        loading={loading}
      />

      {/* Charts and Analytics Grid */}
      <div
        className={`dashboard__charts-grid ${
          hospitalBranchId && isNewBranch
            ? "dashboard__charts-grid--with-sidebar"
            : ""
        }`}
      >
        {/* Job Activity Chart - Takes full width when no sidebar, 2/3 when sidebar is present */}
        <div className="dashboard__chart-main">
          <JobActivityChart
            selectedLocation={selectedLocation}
            locumHoursData={locumHoursData}
            onFilterChange={handleFilterChange}
          />
        </div>

        {/* Credit Limit Section - Only show for new branches */}
        {hospitalBranchId && isNewBranch && (
          <div className="dashboard__chart-sidebar">
            <CreditLimitSection
              branchId={hospitalBranchId}
              creditLimit={selectedBranchData?.creditLimit || 0}
              utilizedLimit={selectedBranchData?.utilizedLimit || 0}
              creditNote={selectedBranchData?.creditNote || ""}
              loading={isLoadingBranch}
              error={branchError}
              hospitalName={selectedBranchData?.jobLocation?.hospitalName || ""}
              branchName={selectedBranchData?.jobLocation?.branchName || ""}
              isNewBranch={isNewBranch}
              billingMode={
                selectedBranchData?.billingInfo?.billingMode || "Postpaid"
              }
            />
          </div>
        )}
      </div>

      {/* Demographics Section */}
      <DemographicsSection
        selectedLocation={hospitalBranch}
        locumHoursData={locumHoursData}
      />

      {/* Education & Skills Section */}
      <EducationSection
        selectedLocation={hospitalBranch}
        locumHoursData={locumHoursData}
      />

      <SidebarNew locumHoursData={locumHoursData} />
    </div>
  );
};

export default Dashboard;
